import React, { useState } from "react";
import ProductListHeader from "./components/ProductListHeader";
import ProductTable from "./components/ProductTable";
import ManageTimingModal from "./components/ManageTimingModal";
import { useProductList } from "./hooks/useProductList";
import "react-toastify/dist/ReactToastify.css";

/**
 * Product List Page
 * Main page component for managing and viewing products
 */
function ProductList() {
  const [searchQuery, setSearchQuery] = useState("");
  const [isTimingModalOpen, setIsTimingModalOpen] = useState(false);

  const {
    products,
    loading,
    page,
    totalPages,
    startIndex,
    setPage,
    handleSort,
  } = useProductList(searchQuery);

  return (
    <div className="h-screen flex flex-col bg-gradient-to-br from-gray-50 via-white to-gray-50 px-2 py-3 overflow-hidden">      {/* Header Section */}
      <div className="flex-shrink-0">
        <ProductListHeader
          searchQuery={searchQuery}
          onSearchChange={(e) => setSearchQuery(e.target.value)}
          onManageTiming={() => setIsTimingModalOpen(true)}
        />
      </div>

      {/* Scrollable Product Table */}
      <div className="flex-1 overflow-hidden">
        <ProductTable
          products={products}
          loading={loading}
          page={page}
          totalPages={totalPages}
          startIndex={startIndex}
          onPageChange={setPage}
          onSort={handleSort}
          searchQuery={searchQuery}
        />
      </div>

      <ManageTimingModal 
        isOpen={isTimingModalOpen} 
        onClose={() => setIsTimingModalOpen(false)} 
      />
    </div>
  );
}

export default ProductList;
